import EmblaCarousel from "embla-carousel";
window.EmblaCarousel = EmblaCarousel;

import {
  Chart,
  ArcElement,
  DoughnutController,
  Tooltip,
} from 'chart.js';
Chart.register(
    ArcElement,
    DoughnutController,
    Tooltip
);

window.Chart = Chart;

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus'

import ajax from '@imacrayon/alpine-ajax';
import intersectClass from 'alpinejs-intersect-class';

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(collapse);

Alpine.plugin(ajax);
Alpine.plugin(intersectClass);

Alpine.start();

// Forms bits (currently just password reveal)
import Forms from './modules/_forms.js';

// Social share links
import Socials from './modules/_social_share_links.js';

function init() {
  Forms.setup();
  Socials.setup();
}

init();